import { sanitize } from 'isomorphic-dompurify';
import React, { Component } from 'react';

import QuillViewerWrapper from './quillviewer.style';

// XSS 방지: contents(HTML)를 렌더 전에 DOMPurify 기본 설정으로 정제한다.
// script/이벤트 핸들러(onerror 등)/javascript: 등 악성 구문을 제거한다.
const sanitizeBody = (html: string): string => sanitize(html || '');

interface IQuillProps {
  body: string;
}

interface IQuillState {
  text: string;
}
class QuillViewer extends Component<IQuillProps, IQuillState> {
  ReactQuill: any;

  constructor(props: IQuillProps) {
    super(props);
    this.state = { text: sanitizeBody(props.body) };
    if (typeof window === 'object' && document) {
      this.ReactQuill = require('react-quill');
      const BigMyeongjoFont = require('./BigMyeongjoFont');
      const CaptionFont = require('./CaptionFont');
      const { DividerTitle, DividerLine } = require('./DividerTitle');
      const { ImageBlot, CardEditableModule } = require('./ImageBlotWithCaption');
      this.ReactQuill.Quill.register(BigMyeongjoFont);
      this.ReactQuill.Quill.register(CaptionFont);
      this.ReactQuill.Quill.register(DividerTitle);
      this.ReactQuill.Quill.register(DividerLine);
      this.ReactQuill.Quill.register(ImageBlot, true);
      this.ReactQuill.Quill.register('modules/cardEditable', CardEditableModule, true);
    }
  }

  componentWillReceiveProps(nextProps: IQuillProps) {
    if (nextProps.body) {
      this.setState({ text: sanitizeBody(nextProps.body) });
    }
  }

  formats = [
    'header',
    'bigmyeongjo',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'align',
    'indent',
    'link',
    'image',
    'video',
    'caption',
    'dividertitle',
    'dividerline',
    'style',
    'width',
  ];

  render() {
    const { ReactQuill } = this;
    return (
      <QuillViewerWrapper>
        {typeof window === 'object' && document ? (
          <ReactQuill
            theme="snow"
            modules={{ toolbar: false }}
            formats={this.formats}
            value={this.state.text}
            readOnly
          />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: this.state.text }} />
        )}
      </QuillViewerWrapper>
    );
  }
}
export default QuillViewer;
